var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPixFlat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M385.857 375.7c-18.204 0-35.326-6.923-48.199-19.491l-69.595-67.978c-4.886-4.785-13.402-4.771-18.287 0l-69.849 68.226c-12.873 12.568-29.995 19.491-48.199 19.491h-13.715l88.145 86.092c27.526 26.887 72.158 26.887 99.687 0l88.395-86.34h-8.383zM131.727 135.256c18.204 0 35.326 6.923 48.199 19.491l69.849 68.236c5.031 4.916 13.244 4.934 18.287-.006l69.595-67.981c12.873-12.568 29.995-19.491 48.199-19.491h8.383l-88.393-86.339c-27.531-26.888-72.163-26.888-99.69 0l-88.14 86.09h13.711z",
    fill: "#32BCAD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M467.355 206.918l-53.417-52.175c-1.176.461-2.45.748-3.795.748h-24.287c-12.556 0-24.848 4.974-33.72 13.647l-69.593 67.975c-6.512 6.361-15.07 9.544-23.62 9.544-8.557 0-17.109-3.183-23.619-9.538l-69.856-68.23c-8.872-8.674-21.164-13.647-33.72-13.647h-29.864c-1.274 0-2.464-.293-3.588-.706l-53.63 52.382c-27.528 26.888-27.528 70.48 0 97.369l53.628 52.38c1.126-.413 2.316-.707 3.59-.707h29.864c12.556 0 24.848-4.972 33.72-13.645l69.849-68.224c12.625-12.321 34.634-12.325 47.246.006l69.593 67.97c8.872 8.672 21.164 13.647 33.72 13.647h24.287c1.345 0 2.619.286 3.795.747l53.417-52.175c27.527-26.888 27.527-70.48 0-97.368",
    fill: "#32BCAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixFlat);
export default __webpack_public_path__ + "static/media/pix-flat.6be94a6bedb3be80f20769edb3ef78fe.svg";
export { ForwardRef as ReactComponent };